export function Busd() {
  return (
    <img
      style={{ height: 25, width: 25 }}
      alt="BUSD logo"
      src="https://pancakeswap.finance/images/tokens/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56.png"
    />
  );
}
